var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3848 5.53846V2.30769C13.3848 2.06287 13.2875 1.82809 13.1144 1.65498C12.9413 1.48187 12.7065 1.38461 12.4617 1.38461H2.30784C2.06303 1.38461 1.82824 1.48187 1.65513 1.65498C1.48202 1.82809 1.38477 2.06287 1.38477 2.30769V21.6923C1.38477 21.9371 1.48202 22.1719 1.65513 22.345C1.82824 22.5181 2.06303 22.6154 2.30784 22.6154H12.4617C12.7065 22.6154 12.9413 22.5181 13.1144 22.345C13.2875 22.1719 13.3848 21.9371 13.3848 21.6923V18.4615",
    stroke: "#040C1E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.07715 12H22.6156",
    stroke: "#040C1E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.69253 7.38461L5.07715 12L9.69253 16.6154",
    stroke: "#040C1E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/Logout.b6282f36.svg";
export { ForwardRef as ReactComponent };